import {AppError} from "../../model/AppError";
import {AppState} from "../store/AppState";

function selectErrors(state: AppState): AppError<any>[]|undefined {
  const { errors } = state;
  return errors || undefined;
}
function compareErrorStates(next: AppState, prev: AppState) {
  return next.errors === prev.errors;
}

const ErrorUtils = {
  selectErrors,
  compareErrorStates
};
export default ErrorUtils;
